// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"274":"93ccfe81","285":"63e28333","353":"457b4411","490":"1267789a","508":"ffd14557","541":"8fb3510f","585":"9db4e6db","621":"ee5b3e98","628":"2c200a3c","673":"39ffc63c","827":"707b271d","913":"e3d3adc8"}[chunkId] + ".chunk.js";
};